var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-mute") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.022088782 4.78676667 0.022088782 4.78676667 7.99996257 0 7.99996257"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.208 0.0771666667 3 0.0771666667 3 2.8695 0.208 2.8695"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37843333,0.0652666667 L1.85076667,1.80093333 C1.76343333,1.86093333 1.58643333,1.89826667 1.43443333,1.89826667 L0.2751,1.89826667 C0.1231,1.89826667 -0.000233333333,2.05026667 -0.000233333333,2.23826667 L-0.000233333333,5.78426667 C-0.000233333333,5.9716 0.1231,6.12393333 0.2751,6.12393333 L1.43443333,6.12393333 C1.58643333,6.12393333 1.76343333,6.16126667 1.85076667,6.22093333 L4.37843333,7.9566 C4.56176667,8.0826 4.78676667,7.91893333 4.78676667,7.65993333 L4.78676667,0.362266667 C4.78676667,0.103266667 4.56176667,-0.0604 4.37843333,0.0652666667",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(5.000000, 2.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14733333,1.47216667 L2.88866667,0.731833333 C2.96133333,0.658833333 3.001,0.561833333 3.00001846,0.458833333 C2.99933333,0.356833333 2.95933333,0.2615 2.888,0.1905 C2.74133333,0.0445 2.493,0.0445 2.34533333,0.1905 L1.60533333,0.930166667 L0.862666667,0.188166667 C0.792666667,0.117833333 0.694,0.0771666667 0.591666667,0.0771666667 L0.591333333,0.0771666667 C0.489,0.0771666667 0.390333333,0.117833333 0.322,0.186166667 C0.248333333,0.258166667 0.208,0.354833333 0.208,0.458833333 C0.208,0.5625 0.248333333,0.659166667 0.320333333,0.729833333 L1.063,1.47216667 L0.408333333,2.12583333 C0.377333333,2.15683333 0.354333333,2.1805 0.336666667,2.19883333 L0.321333333,2.21383333 C0.248333333,2.28616667 0.208,2.38283333 0.208,2.48616667 C0.208,2.58883333 0.248,2.68516667 0.318333333,2.75483333 C0.391,2.82916667 0.484,2.8535 0.591333333,2.8695 C0.694333333,2.8695 0.790666667,2.82916667 0.862333333,2.75683333 L1.60533333,2.0145 L2.34633333,2.7555 C2.49633333,2.90316667 2.73833333,2.9025 2.889,2.75283333 C2.96133333,2.67983333 3.001,2.58316667 3.00001846,2.48016667 C2.99933333,2.3775 2.95933333,2.28183333 2.88766667,2.21183333 L2.14733333,1.47216667 Z",
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMute);
export default __webpack_public_path__ + "static/media/icon-mute.290142717450d9ffa16055fc799dced4.svg";
export { ForwardRef as ReactComponent };